import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-terms-condition',
    templateUrl: './terms-condition.component.html',
    styleUrls: ['./terms-condition.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TermsConditionComponent {

}
